import { useMutation, UseMutationOptions } from 'react-query';

import { getRequest } from 'services/apiRequests';
import { BackendGetDataFieldValuesQueryParams, toBackEndQueryParams } from 'services/dataFieldValues';
import type { StringifiedUUID } from 'types';
import { TQPrefetchDataFieldValuesParams } from 'types/dataFieldValue';
import type { APIError } from 'utils/errors';

export type TQPrefetchDataFieldValuesResponse = {
  prefetch_token: string;
  aggregation_id: string;
};

const prefetchApiUrl = (modelId: StringifiedUUID, dataObjectSchemaId: StringifiedUUID) => {
  return `/api/v1/tq/hierarchy-models/${modelId}/data-object-schemas/${dataObjectSchemaId}/data-field-values/prefetch-records/`;
};

export const prefetchDataFieldValues = (params: TQPrefetchDataFieldValuesParams) => {
  const { modelId, dataObjectSchemaId, ...queryParams } = params;
  const backendParams = toBackEndQueryParams(queryParams);

  const url = prefetchApiUrl(modelId, dataObjectSchemaId);
  return getRequest<BackendGetDataFieldValuesQueryParams, TQPrefetchDataFieldValuesResponse>(url, backendParams);
};

export const usePrefetchDataFieldValuesMutation = (
  options: UseMutationOptions<TQPrefetchDataFieldValuesResponse, APIError, TQPrefetchDataFieldValuesParams> = {},
) => {
  return {
    mutation: useMutation<TQPrefetchDataFieldValuesResponse, APIError, TQPrefetchDataFieldValuesParams>(
      prefetchDataFieldValues,
      options,
    ),
  };
};
